import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';

const ENDPOINT = import.meta.env.DEV
  ? 'http://localhost:8080'
  : 'https://property-tax-api.yourwayhome.com';

export interface Profile {
  emailAddress: string;
  firstName: string;
  lastName?: string;
  auth0Id: string;
  createdAt: string;
  phoneNumber?: string;
  role?: 'AGENT' | 'USER';
  companyName?: string;
  licenseNumber?: string;
  photoUrl?: string;
  website?: string;
  identifier?: string;
  agent?: Profile;
}

export default function useGetProfile() {
  const { isAuthenticated } = useAuth0();
  const token = window.localStorage.getItem('_token');

  return useQuery<Profile>({
    queryKey: ['PROFILE'],
    queryFn: async () => {
      const response = await fetch(`${ENDPOINT}/api/v1/users/profile`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch profile: ${response.statusText}`);
      }

      const { user, agent } = (await response.json()).data;

      return { ...user, agent };
    },
    enabled: isAuthenticated && !!token,
  });
}
